import { stripCurrencyFormatting } from "../../../../Utilities/regex";
import { getPlaceholderForEmptyString } from "../../../../utils/emptyStringCheck";
import { formatNumber } from "../../../../utils/numberFormatterUtil";

export const sectionType = {
  ticketDetail: "ticketDetail",
  jobInformation: "jobInformtion",
  carrierDetails: "carrierDetails",
};

const getPricingValue = (price, priceType) =>
  !!price && !!priceType
    ? `$${formatNumber(Number(price).toFixed(2))} per ${priceType}`
    : "-";

export const ticketUploadDetailsLabels = (data) => [
  ["Customer", getPlaceholderForEmptyString(data?.companyName), 11, 13],
  ["Job Name", getPlaceholderForEmptyString(data?.jobName), 11, 13],
  ["Order Name", getPlaceholderForEmptyString(data?.orderNumber), 11, 13],
  [
    "Approved Trucks",
    getPlaceholderForEmptyString(data?.approvedTruck),
    11,
    13,
  ],
  ["Uploaded by", getPlaceholderForEmptyString(data?.createdBy), 11, 13],
  [
    "Quality Verification by",
    getPlaceholderForEmptyString(data?.updatedBy),
    11,
    13,
  ],
];

export const jobInformationLabels = (data) => [
  ["Quarry Name", getPlaceholderForEmptyString(data?.quarryName), 10, 14],
  ["Material", getPlaceholderForEmptyString(data?.material), 10, 14],
  ["Pickup", getPlaceholderForEmptyString(data?.pickUpAddress), 10, 14],
  ["Drop Off", getPlaceholderForEmptyString(data?.dropoffAddress), 10, 14],
  [
    "Trucking Rate",
    getPricingValue(data?.truckingPrice, data?.truckingPriceType),
    10,
    14,
  ],
  [
    "Material Rate",
    getPricingValue(data?.materialPrice, data?.materialPriceType),
    10,
    14,
  ],
  ["Truck Type", getPlaceholderForEmptyString(data?.truckType), 10, 14],
];

export const carrierDetailsLabels = (data) => [
  ["Carrier Name", getPlaceholderForEmptyString(data?.carrierName), 10, 14],
  ["Carrier Phone", getPlaceholderForEmptyString(data?.carrierPhone), 10, 14],
  ["Contact Name", getPlaceholderForEmptyString(data?.contactName), 10, 14],
  ["Contact Phone", getPlaceholderForEmptyString(data?.contactPhone), 10, 14],
];

export const sectionLabels = {
  TICKET_UPLOAD: "Ticket Upload Details",
  JOB_INFORMATION: "Job Information",
  CARRIER_DETAILS: "Carrier Details",
};

export const getDetailsValues = (type: string, data?: any) => {
  switch (type) {
    case sectionType.ticketDetail:
      return ticketUploadDetailsLabels(data?.ticketUploadDetails);

    case sectionType.jobInformation:
      return jobInformationLabels(data?.jobInformation);

    case sectionType.carrierDetails:
      return carrierDetailsLabels(data?.carrierDetails);
  }
};

export const getTicketDetailValues = (data: any) => [
  [
    sectionLabels.TICKET_UPLOAD,
    getDetailsValues(sectionType.ticketDetail, data),
  ],
  [
    sectionLabels.JOB_INFORMATION,
    getDetailsValues(sectionType.jobInformation, data),
  ],
  [
    sectionLabels.CARRIER_DETAILS,
    getDetailsValues(sectionType.carrierDetails, data),
  ],
];
